import { render, staticRenderFns } from "./BiReportView.vue?vue&type=template&id=4e9dba03"
import script from "./BiReportView.vue?vue&type=script&lang=js"
export * from "./BiReportView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports